import APP from './app';

const IMAGE = {
  MAX_IMAGE_SIZE_KB: 10_000_000, // 10MB
  VALID_IMAGE_MIME_TYPES: [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp',
  ],
  LOGO_PATH: `${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`,
};

export default IMAGE;
